import { defineNuxtPlugin, useHead, useImage } from '#imports';
import { NuxtLink } from '#components';
import { setConfig } from '@i22team/td-longtail-vue-components';
import tealium from '~/lib/tealium';

// Set runtime env to component lib.
export default defineNuxtPlugin((nuxtApp) => {
  setConfig({
    cloudFront: {
      ...nuxtApp.$config.public.cloudFront,
      url: nuxtApp.$config.app.cdnURL,
    },
    imageOptimizer: useImage().getSizes,
    currentRoute: useRoute() as unknown as Ref<unknown>,
    useHead,
    nuxtLink: NuxtLink,
    tealium,
    isSSR: import.meta.server,
  });
});
